import React, { useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCountryDetails, clearError, clearLocationDetails } from '../../../redux/Slices/LocationsSlice';
import { showErrorToast } from '../../../shared/utils/toastHelper';

const CountryDetails = () => {
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    
    const { countryDetails, loading, error } = useSelector((state) => state.locations);

    useEffect(() => {
        setTitle('تفاصيل الدولة');
        dispatch(fetchCountryDetails(id));
        
        return () => {
            dispatch(clearLocationDetails());
        };
    }, [setTitle, dispatch, id]);

    useEffect(() => {
        if (error) {
            showErrorToast(error);
            dispatch(clearError());
        }
    }, [error, dispatch]);

    if (loading || !countryDetails) {
        return (
            <div className="main_content text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 text-muted">جاري تحميل بيانات الدولة...</p>
            </div>
        );
    }

    return (
        <div className="main_content">
            <div className="dashboard-container">
                <div className="card shadow-lg border-0">
                    <div className="card-header bg-white pb-0 border-0 d-flex justify-content-between align-items-center">
                        <h4 className="mb-0">تفاصيل دولة #{id}</h4>
                        <div>
                            <button className="btn btn-warning mx-2 text-white" onClick={() => navigate(`/admin-locations/countries/${id}/edit`)}>
                                تعديل
                            </button>
                            <button className="btn btn-secondary" onClick={() => navigate('/admin-locations/countries')}>
                                عودة للقائمة
                            </button>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row g-4 mt-2">
                            <div className="col-md-6 border-bottom pb-3">
                                <h6>اسم الدولة (بالعربية)</h6>
                                <p className="text-muted fw-bold mb-0">{countryDetails.name_ar || countryDetails.name || '-'}</p>
                            </div>
                            <div className="col-md-6 border-bottom pb-3">
                                <h6>اسم الدولة (بالإنجليزية)</h6>
                                <p className="text-muted fw-bold mb-0">{countryDetails.name_en || '-'}</p>
                            </div>
                            {/* <div className="col-md-6 border-bottom pb-3">
                                <h6>تاريخ الإضافة</h6>
                                <p className="text-muted mb-0">
                                    {countryDetails.created_at ? new Date(countryDetails.created_at).toLocaleDateString('ar-EG') : '-'}
                                </p>
                            </div>
                            <div className="col-md-6 border-bottom pb-3">
                                <h6>تاريخ التحديث</h6>
                                <p className="text-muted mb-0">
                                    {countryDetails.updated_at ? new Date(countryDetails.updated_at).toLocaleDateString('ar-EG') : '-'}
                                </p>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CountryDetails;
